import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateSubDomain = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, subdomainName }) => {
            return client.put(
                replaceParameters(ORGANIZATION.SUB_DOMAIN.url, { uuid }),
                { subdomainName }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateSubDomain;